import { render, staticRenderFns } from "./PptStudy.vue?vue&type=template&id=48c355e0&scoped=true&"
import script from "./PptStudy.vue?vue&type=script&lang=js&"
export * from "./PptStudy.vue?vue&type=script&lang=js&"
import style0 from "./PptStudy.vue?vue&type=style&index=0&id=48c355e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c355e0",
  null
  
)

export default component.exports